import React, {useState, Fragment, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Fab from '@material-ui/core/Fab'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'

// Material-UI Icon
import FolderIcon from '@material-ui/icons/Folder'
import StorageIcon from '@material-ui/icons/Storage'

// Custom Component
import AttachmentChip from '../Chip/AttachmentChip'

// Custom Style
import {docSubZoneContentStyle} from '../../styles/jss/components/documentSubmission/docSubZoneContentStyle'

// Fetch Data
import {fileDownload} from '../../dataSource/fileManager'


const useStyles = makeStyles(theme => docSubZoneContentStyle(theme))

const DocSubZoneContent = props => {
	const store = require('store')
	const dispatch = useDispatch()

	const classes = useStyles()
	const {title, fileType, open, fileRemoveAction, viewFileAction, openFileManagerDialog} = props

	// Redux Data
	// const drawingPropertyRedux = useSelector(state => state.drawingPropertyRedux)
	const documentSubmissionCreateValueRedux = useSelector(state => state.documentSubmissionCreateValueRedux)
	const fileUploadingPropertyRedux = useSelector(state => state.fileUploadingPropertyRedux)

	
	// const downloadFileAction = (fileCat, fileSeq) => {
	// 	fileDownload(fileCat, fileSeq).then(res => {
	// 		console.log("*****************************************************************************")
	// 		console.log("System Module: Document Submission")
	// 		console.log("Message: File download successful.")
	// 		console.log("*****************************************************************************")
	// 	})
	// }


	useEffect(() => {
	})


	return (

		// console.log("Upload file type | Variable: fileType (DocSubZoneContent.js)"),
		// console.log(fileType),

		// console.log("Document Submisstion Create Value (Redux) | Variable: documentSubmissionCreateValueRedux (DocSubZoneContent.js)"),
		// console.log(documentSubmissionCreateValueRedux),

		// console.log("File Uploading (Redux) | Variable: fileUploadingPropertyRedux (DocSubZoneContent.js)"),
		// console.log(fileUploadingPropertyRedux),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div className={classes.messageAttachmentArea}>
				{
					fileUploadingPropertyRedux !== null ?
						fileUploadingPropertyRedux[fileType].map((res, index) => {
							return (
								<AttachmentChip
									key={index}
									id={index}
									filename={res.name}
									fileSize={res.filesize}
									fileExtension={"other"}
									uploading={true}
									viewFileAction={null}
									downloadFileAction={null}
									fileRemoveAction={null}
								/>
							)
						})
					: ""
				}

				{
					documentSubmissionCreateValueRedux !== null ?
						documentSubmissionCreateValueRedux.files[fileType].map((res, index) => {
							return (
								<AttachmentChip
									key={index}
									id={res.file_seq}
									filename={res.filename}
									fileSize={res.filesize}
									fileExtension={res.extension}
									viewFileAction={() => viewFileAction("master", res.file_seq, res.filename)}
									downloadFileAction={null}
									fileRemoveAction={() => fileRemoveAction(fileType, res.file_seq)}
								/>
							)
						})
					: ""
				}
			</div>

			<Box className={classes.fileUploadBtnArea}>
				{/* <Tooltip title="Add File From eFiling">
					<Fab color="primary" size="small" aria-label="add_recipient" className={classes.addFileBtn} onClick={openFileManagerDialog}>
						<FolderIcon />
					</Fab>
				</Tooltip> */}

				<Tooltip title="Add File From Hard Disk">
					<Fab color="primary" size="small" aria-label="add_recipient" className={classes.addFileBtn} onClick={open}>
						<StorageIcon />
					</Fab>
				</Tooltip>
			</Box>
		</Fragment>
	)
}

export default DocSubZoneContent